import React, { useState } from 'react';
import { Avatar, Box, Hidden, Divider } from '@material-ui/core';
// import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import musafirbazarlogo from '../../assets/images/r2.png';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import TitleText from './TitleText';
import IMAGES from '../../constants/logo.js';
import { useHistory } from 'react-router-dom';
import BodyText from './BodyText';
import { useDispatch, useSelector } from 'react-redux';
import SuccessModal from './SuccessModal';
import {
	toggleRegisterModal,
	toggleRegisterTravellerModal,
} from '../../reducers/UiReducer';
import {
	agentloginDispatch,
	travellerloginDispatch,
} from '../../reducers/UserReducer';
import ErrorModal from './ErrorModal';
import RegisterAgentModal from './RegisterAgentModal';
import RegisterTravellerModal from './RegisterTravellerModal';
const HeaderSection = ({ id }) => {
	const dispatch = useDispatch();
	const handleTheme = () => {
		let themeBtn = document.querySelector('#theme-btn');
		themeBtn.classList.toggle('fa-sun');

		if (themeBtn.classList.contains('fa-sun')) {
			document.body.classList.add('active');
		} else {
			document.body.classList.remove('active');
		}
	};

	const [user, setUser] = useState({
		username: '',
		password: '',
	});
	const { username, password } = user;
	const onInputChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};
	const onSubmit = async (e) => {
		e.preventDefault();
		var dat = user;
		var formData = JSON.stringify(dat);
		console.log(formData);
		// dispatch(travellerloginDispatch(formData, history));
		dispatch(agentloginDispatch(formData, history));
	};
	const onSubmit2 = async (e) => {
		e.preventDefault();
		var dat = user;
		var formData = JSON.stringify(dat);
		console.log(formData);
		dispatch(travellerloginDispatch(formData, history));
		// dispatch(agentSignupDispatch(formData, history));
	};
	const history = useHistory();
	const handleChange = (e) => {
		console.log(e.target.name[0]);
	};
	const { travellerlogin, agentlogin, walletagent, wallet } = useSelector(
		(state) => state.user
	);
	return (
		<>
			<header className='header'>
				<a className='logo'>
					<img
						style={{ cursor: 'pointer' }}
						src={musafirbazarlogo}
						onClick={() => history.push('/')}></img>
				</a>
				<Hidden only={['xs']}>
					<Box display='flex'>
						<Box
							display='flex'
							alignItems='center'
							onClick={() => history.push('/home')}>
							{/* <img
								src={flightnew}
								style={{
									filter:
										id == 1
											? ' invert(46%) sepia(45%) saturate(4226%) hue-rotate(348deg) brightness(96%) contrast(91%)'
											: '',
								}}></img> */}
							<TitleText
								four
								textStyle={{
									color: id == 1 ? '#EC5B25' : '',
									fontFamily: 'unset',
									fontWeight: 500,
								}}>
								My Account
							</TitleText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							ml={'30px'}
							onClick={() => history.push('/new')}>
							<TitleText
								four
								textStyle={{
									color: id == 2 ? '#EC5B25' : '',
									fontFamily: 'unset',
									fontWeight: 500,
								}}>
								Support
							</TitleText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							ml={'30px'}
							onClick={() => history.push('/buses')}>
							<TitleText
								four
								textStyle={{
									color: id == 3 ? '#EC5B25' : '',
									fontFamily: 'unset',
									fontWeight: 500,
								}}>
								Offers
							</TitleText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							ml={'30px'}
							onClick={() => history.push('/flightdeal')}>
							<TitleText
								four
								textStyle={{
									color: id == 4 ? '#EC5B25' : '',
									marginLeft: 5,
									fontFamily: 'unset',
									fontWeight: 500,
								}}>
								Deals
							</TitleText>
						</Box>
						<Hidden only={['xs', 'sm']}>
							<Box display='flex' alignItems='center'>
								{travellerlogin && travellerlogin.status === 200 ? (
									<Box
										ml={'10px'}
										display='flex'
										alignItems='center'
										style={{ cursor: 'pointer' }}
										onClick={() => history.push('/dashboard')}>
										<Avatar
											style={{
												color: 'white',
												background: 'rgb(239, 51, 57)',
											}}>
											{travellerlogin &&
												travellerlogin.result &&
												travellerlogin.result.result.name
													.match(/(\b\S)?/g)
													.join('')
													.match(/(^\S|\S$)?/g)
													.join('')
													.toUpperCase()}
										</Avatar>
										<p style={{ marginLeft: 10, fontSize: 20 }}>
											{wallet && wallet.result && wallet.result.balanceAmount}
										</p>
									</Box>
								) : agentlogin && agentlogin.status === 200 ? (
									<Box
										ml={'10px'}
										display='flex'
										alignItems='center'
										style={{ cursor: 'pointer' }}
										onClick={() => history.push('/dashboard')}>
										<Avatar
											style={{
												color: 'white',
												background: 'rgb(239, 51, 57)',
											}}>
											{agentlogin &&
												agentlogin.result &&
												agentlogin.result.result.name
													.match(/(\b\S)?/g)
													.join('')
													.match(/(^\S|\S$)?/g)
													.join('')
													.toUpperCase()}
										</Avatar>
										{/* <TitleText textStyle={{ marginLeft: 10 }}>
											{agentlogin &&
												agentlogin.result &&
												agentlogin.result.result.name}
										</TitleText> */}
										<p style={{ marginLeft: 10, fontSize: 20 }}>
											{walletagent &&
												walletagent.result &&
												walletagent.result.balanceAmount}
										</p>
									</Box>
								) : (
									<>
										<Box
											onClick={() => {
												let loginForm = document.querySelector('.login-form');
												let navbar = document.querySelector('.navbar');
												loginForm.classList.toggle('active');
												navbar.classList.remove('active');
												// history.push('/agent');
											}}
											ml={'20px'}
											// id='btnSubmit'
											display='flex'
											alignItems='center'
											style={{
												background: '#ef3339',
												padding: '5px 14px',
												color: 'white',
												borderRadius: 16,
												cursor: 'pointer',
											}}>
											<i className='fas fa-user'></i>
											<TitleText textStyle={{ marginLeft: 10 }}>
												Agent
											</TitleText>
										</Box>
										<Box
											onClick={() => {
												let loginForm = document.querySelector('.login-form2');
												let navbar = document.querySelector('.navbar2');
												loginForm.classList.toggle('active2');
												navbar.classList.remove('active2');
												// history.push('/traveller');
											}}
											ml={'20px'}
											// id='btnSubmit'
											display='flex'
											alignItems='center'
											style={{
												background: '#ef3339',
												padding: '5px 14px',
												color: 'white',
												borderRadius: 16,
												cursor: 'pointer',
											}}>
											<i className='fas fa-user'></i>
											<TitleText textStyle={{ marginLeft: 10 }}>
												Traveller
											</TitleText>
										</Box>
									</>
								)}
							</Box>
						</Hidden>
					</Box>
				</Hidden>
				<Hidden only={['lg', 'xl', 'sm', 'md']}>
					<div className='icons'>
						{/* <div
						className='fas fa-moon'
						id='theme-btn'
						onClick={handleTheme}></div>
					<div className='fas fa-user' id='login-btn'></div> */}
						<div
							className='fas fa-bars'
							id='menu-btn'
							onClick={() => {
								let navbar = document.querySelector('.navbar');
								navbar.classList.toggle('active');
								// navbar.classList.add('active');
							}}></div>
					</div>
				</Hidden>

				<nav className='navbar'>
					<a href='#home'> My Account</a>
					<a href='#packages'>Support</a>
					<a href='#services'>Offer</a>
					<a href='#pricing'>Deals</a>
					<a href='#review'>Login</a>
				</nav>

				<form onSubmit={(e) => onSubmit(e)} className='login-form'>
					<div className='inputBox'>
						<span>Username</span>
						<input
							type='email'
							name='username'
							value={username}
							onChange={(e) => onInputChange(e)}
							placeholder='enter your name'
						/>
					</div>

					<div className='inputBox'>
						<span>Password</span>
						<input
							type='password'
							name='password'
							value={password}
							onChange={(e) => onInputChange(e)}
							placeholder='enter your password'
						/>
					</div>

					{/* <div className='remember'>
						<input type='checkbox' name='' id='login-remember' />
						<label for='login-remember'>remember me</label>
					</div> */}

					<input
						onClick={() => {
							let loginForm = document.querySelector('.login-form');
							loginForm.classList.toggle('active');
						}}
						type='submit'
						className='btn'
						value='LOGIN'
						style={{ textAlign: 'center' }}
					/>
					<Box onClick={() => dispatch(toggleRegisterModal(true))}>
						<BodyText
							textStyle={{
								color: '#E61855',
								fontWeight: 600,
								marginTop: 10,
								fontSize: 14,
								cursor: 'pointer',
								textAlign: 'center',
							}}>
							Signup
							<Divider style={{ backgroundColor: '#E61855', marginTop: 20 }} />
						</BodyText>
					</Box>
				</form>
				<form onSubmit={(e) => onSubmit2(e)} className='login-form2'>
					<div className='inputBox2'>
						<span>Username</span>
						<input
							type='email'
							name='username'
							value={username}
							onChange={(e) => onInputChange(e)}
							placeholder='enter your name'
						/>
					</div>

					<div className='inputBox2'>
						<span>Password</span>
						<input
							type='password'
							name='password'
							value={password}
							onChange={(e) => onInputChange(e)}
							placeholder='enter your password'
						/>
					</div>

					{/* <div className='remember'>
						<input type='checkbox' name='' id='login-remember' />
						<label for='login-remember'>remember me</label>
					</div> */}

					<input
						onClick={() => {
							let loginForm = document.querySelector('.login-form2');
							loginForm.classList.toggle('active2');
						}}
						type='submit'
						className='btn'
						value='login'
						style={{ textAlign: 'center' }}
					/>
					<Box onClick={() => dispatch(toggleRegisterTravellerModal(true))}>
						<BodyText
							textStyle={{
								color: '#E61855',
								fontWeight: 600,
								marginTop: 10,
								fontSize: 14,
								cursor: 'pointer',
								textAlign: 'center',
							}}>
							Signup
							<Divider style={{ backgroundColor: '#E61855', marginTop: 20 }} />
						</BodyText>
					</Box>
				</form>
			</header>
			<RegisterAgentModal />
			<RegisterTravellerModal />
			<SuccessModal />
			<ErrorModal />
		</>
	);
};

export default HeaderSection;
